<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data">
        <div class="data-title flex-space-between" slot="header">
          <p>End User Licence Agreement</p>
          <div>
          </div>
        </div>
        <el-form ref="eula" label-position="top">
          <div>
            <p class="inline-eye">Text</p>
            <i
              class="el-icon-view ml10"
              @click="openPreview(text)"
            ></i>
          </div>        
          <el-form-item prop="text">
            <vue-editor v-model="text" :editorToolbar="customToolbar"/>
          </el-form-item>
        </el-form>
        <div class="float-right mb20">
          <el-button
            type="primary"
            size="mini"
            @click="submit()"
          >
            Save
          </el-button>
        </div>        
        <Preview :previewText="text"/>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex'
import { VueEditor } from "vue2-editor"
import Preview from '@/global/components/Preview'
import axios from '@/plugins/axios'

export default {
  components: {
    VueEditor,
    Preview
  },

  data() {
    return {
      text: '',
      version: ''
    }
  },  

  methods: {
    ...mapMutations('global', ['setPreview']),

    openPreview(sometext) {
      this.setPreview(true)
      this.text = sometext
    },
    
    submit() {
      axios.admin
        .put('cms/legal/eula', {
          text: this.text,
          version: this.version
        })
    }    
  },
  
  created() {
      axios.admin
        .get('cms/legal/eula')        
        .then(r => {
          this.text = r.data.data[0].text
          this.version = r.data.data[0].version
        })
  }  
}
</script>


<style scoped>
.inline-eye {
  display: inline-block;
}
</style>
